import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { designTokens } from "@cinch-labs/design-system";
import styles from "./svg.module.css";
var _ds = designTokens.customProperties.ds, palette = _ds.color;
export var GRADIENT_IDS = {
    alpha: "svg-gradient-alpha",
    bravo: "svg-gradient-bravo",
    charlie: "svg-gradient-charlie",
    delta: "svg-gradient-delta"
};
export var DEFAULT_GRADIENT_ID = "alpha";
var Gradient = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        className: styles.gradient,
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ _jsxs("linearGradient", {
                id: GRADIENT_IDS.alpha,
                x2: "1",
                y2: "1",
                children: [
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "0%",
                        stopColor: palette.deepPurple
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "100%",
                        stopColor: palette.pearlescentPink
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("linearGradient", {
                id: GRADIENT_IDS.bravo,
                x2: "1",
                y2: "1",
                children: [
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "0%",
                        stopColor: palette.iceBlue
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "100%",
                        stopColor: palette.goGreen
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("linearGradient", {
                id: GRADIENT_IDS.charlie,
                x2: "1",
                y2: "1",
                children: [
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "0%",
                        stopColor: palette.vividViolet
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "100%",
                        stopColor: palette.iceBlue
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("linearGradient", {
                id: GRADIENT_IDS.delta,
                x2: "1",
                y2: "1",
                children: [
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "0%",
                        stopColor: palette.vividViolet
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "100%",
                        stopColor: palette.warmOrange
                    })
                ]
            })
        ]
    });
};
export default Gradient;
